import * as angular from "angular";
import * as _ from "lodash";
import BrowserPrint from "zebra-browser-print-wrapper";

// const browserPrintRef = require('zebra-browser-print-wrapper');

import {IQService, IWindowService} from "angular";
import {SplitService} from "./split-service.service";
import {LabelPrintTemplateType} from "../types/label-print-template.type";
import {zplToBase64Async} from "zpl-renderer-js";
import { jsPDF } from 'jspdf';

export class PrinterService {
  storage: any;
  defaultPrinter: any;
  selectedPrinter: any;
  printerList: any = [];

  public browserPrintRef: any;

  constructor(private $q: IQService, private $log, private $timeout, private $window: IWindowService,
              private $filter, private $mdDialog, private splitService: SplitService) {
    this.browserPrintRef = new BrowserPrint();
    this.storage = this.$window.localStorage;
  }

  getPrintingConfig() {
    const storagePrinterConfig = this.storage.getItem('printerConfig');
    return storagePrinterConfig ? JSON.parse(storagePrinterConfig) : {};
  }

  setPrintingConfig(printingConfig) {
    if (printingConfig.uid && this.printerList.length) {
      this.selectedPrinter = _.find(this.printerList, (p) => {
        return p.uid === printingConfig.uid;
      })
    }
    this.storage.setItem('printerConfig', JSON.stringify(printingConfig));
  }

  getLocalDevices() {
    const deferred = this.$q.defer();
    this.browserPrintRef.getAvailablePrinters()
      .then((device_list) => {
        this.printerList = device_list || [];
        deferred.resolve(this.printerList);
      })
      .catch((error) => {
        deferred.reject(error);
      })
    return deferred.promise;
  }

  getDefaultDevice() {
    const deferred = this.$q.defer();
    this.browserPrintRef.getDefaultPrinter()
      .then((device) => {
        this.defaultPrinter = device;
        deferred.resolve(device);
      })
      .catch((error) => {
        deferred.reject(error);
      })
    return deferred.promise;


    // const deferred = this.$q.defer();
    // this.browserPrintRef.getDefaultPrinter(
    //   "printer",
    //   (device) => {
    //     this.defaultPrinter = device;
    //     deferred.resolve(device);
    //   },
    //   (error) => {
    //     deferred.reject(error);
    //   }
    // );
    //
    // return deferred.promise;
  }

  getSelectedPrinter() {
    return this.selectedPrinter;
  }

  getPrintingCode() {
    const storagePrinterConfig = this.getPrintingConfig();
    return storagePrinterConfig.code;
  }

  setPrinterCode(code) {
    const storagePrinterConfig = this.getPrintingConfig();
    storagePrinterConfig.code = code;
    this.storage.setItem('printerConfig', JSON.stringify(storagePrinterConfig));
  }

  setSelectedPrinter(printer) {
    if (printer) {
      this.selectedPrinter = _.find(this.printerList, (p) => {
        return p.uid === printer.uid;
      }) || this.printerList[0];
      // selectedPrinter = printer;
      this.browserPrintRef.setPrinter(this.selectedPrinter);
      const storagePrinterConfig = this.getPrintingConfig();
      storagePrinterConfig.uid = printer.uid;
      this.storage.setItem('printerConfig', JSON.stringify(storagePrinterConfig));
    }
  }

  setPrintingEnabled(isEnabled) {
    const storagePrinterConfig = this.getPrintingConfig();
    storagePrinterConfig.enabled = isEnabled;
    this.storage.setItem('printerConfig', JSON.stringify(storagePrinterConfig));
  }

  // function print(accountName, customerName, customerAddress, barcode,
  //     deliveryId, copies, notAfter, printer) {
  //   var template;
  //   var printedCopies = 0;
  //
  //   if (!copies) {
  //     copies = 1;
  //   }
  //
  //   if (!printer) {
  //     printer = selectedPrinter;
  //   }
  //
  //   _.times(copies, function () {
  //     var finalizeTemplate;
  //     var barcode = _.get(item, 'barcode');
  //
  //     printedCopies++;
  //     template = _getPrintTemplate(accountName, customerName, customerAddress, barcode, deliveryId, copies, printedCopies, notAfter);
  //     finalizeTemplate = _getFinalizeTemplate(template);
  //     _write(printer, finalizeTemplate, copies);
  //   });
  // }

  printDelivery(delivery?, printer?) {

    // const dropoff = _.filter(delivery.taskList, (t) => {
    //   return t.taskSpec.purpose === 'Dropoff';
    // })[0];

    const taskRef = delivery.taskList?.length ? _.last(delivery.taskList) : delivery.destination;


    let template;
    let printedCopies = 0;
    const labelPrintTemplateType = this.splitService.getLabelPrinterTemplateType();
    const accountName = _.get(delivery, 'account.name') || _.get(delivery, 'supplierAccountReference.name');
    const resourceName = _.get(delivery, 'routeReference.resourceName') || _.get(delivery, 'supplierAccountReference.name');
    const customerName = _.get(taskRef, 'taskSpec.contact.name');
    const businessName = _.get(taskRef, 'taskSpec.contact.businessName');
    const customerPhone = this.$filter('bringozPhone')(_.get(taskRef, 'taskSpec.contact.phoneNo') || _.get(taskRef, 'contact.phoneNo'));
    const customerAddress = _.get(taskRef, 'taskSpec.address') || _.get(taskRef, 'address');
    const deliveryId = _.get(delivery, 'id');
    const packageItems = _.get(delivery, 'packageList[0].items') || _.get(delivery, 'items') || [];
    const totalCopies = packageItems.length;

    const notAfter = _.get(delivery, 'notAfter') || _.get(taskRef, 'notAfter');
    // var code = getPrintingCode() || '';

    if (!printer) {
      printer = this.selectedPrinter;
    }

    _.forEach(packageItems, (item) => {
      this.$timeout(100).then(() => {
        let finalizeTemplate;
        const barcode = _.get(item, 'barcode');

        printedCopies++;

        const count = item.count || 1;
        _.times(count, (itemCount: number) => {

          if (labelPrintTemplateType === LabelPrintTemplateType.Bergstrom && itemCount > 0) {
            printedCopies++;
          }

          template = labelPrintTemplateType === LabelPrintTemplateType.Netcost ?
            this.getNetcostPrintTemplate(delivery, resourceName, customerName, customerPhone, customerAddress, barcode, deliveryId, totalCopies, printedCopies, notAfter) :
            (labelPrintTemplateType === LabelPrintTemplateType.Bergstrom ?
              this.getBergstromPrintTemplate2(delivery, accountName, resourceName, customerName, businessName, customerPhone, customerAddress, barcode, deliveryId, totalCopies, printedCopies, (itemCount + 1), item.count) :
              this.getDefaultPrintTemplate(delivery, (resourceName || accountName), customerName, businessName, customerPhone, customerAddress, barcode, deliveryId, totalCopies, printedCopies, (itemCount + 1), item.count))
          finalizeTemplate = this.getFinalizeTemplate(template);
          this.write(printer, finalizeTemplate, totalCopies);
        })

        // template = this.getDefaultPrintTemplate(delivery, (resourceName || accountName), customerName, businessName, customerPhone, customerAddress, barcode, deliveryId, totalCopies, printedCopies, notAfter);
        // // template = this.getPrintTemplate(delivery, resourceName, customerName, customerPhone, customerAddress, barcode, deliveryId, totalCopies, printedCopies, notAfter);
        // finalizeTemplate = this.getFinalizeTemplate(template);

        // const count = item.count || 1;
        // _.times(count, (i) => {
        //   this.write(printer, finalizeTemplate, totalCopies);
        // })
      })
    });
  }

  downloadDeliveryToPdf(delivery) {

    const taskRef = delivery.taskList?.length ? _.last(delivery.taskList) : delivery.destination;


    let template;
    let printedCopies = 0;
    const labelPrintTemplateType = this.splitService.getLabelPrinterTemplateType();
    const accountName = _.get(delivery, 'account.name') || _.get(delivery, 'supplierAccountReference.name');
    const resourceName = _.get(delivery, 'routeReference.resourceName') || _.get(delivery, 'supplierAccountReference.name');
    const customerName = _.get(taskRef, 'taskSpec.contact.name');
    const businessName = _.get(taskRef, 'taskSpec.contact.businessName');
    const customerPhone = this.$filter('bringozPhone')(_.get(taskRef, 'taskSpec.contact.phoneNo') || _.get(taskRef, 'contact.phoneNo'));
    const customerAddress = _.get(taskRef, 'taskSpec.address') || _.get(taskRef, 'address');
    const deliveryId = _.get(delivery, 'id');
    const packageItems = _.get(delivery, 'packageList[0].items') || _.get(delivery, 'items') || [];
    const totalCopies = packageItems.length;

    const notAfter = _.get(delivery, 'notAfter') || _.get(taskRef, 'notAfter');
    const zplList: string[] = [];

    _.forEach(packageItems, (item) => {
      const barcode = _.get(item, 'barcode');

      printedCopies++;

      const count = item.count || 1;
      _.times(count, (itemCount: number) => {

        if (labelPrintTemplateType === LabelPrintTemplateType.Bergstrom && itemCount > 0) {
          printedCopies++;
        }

        template = labelPrintTemplateType === LabelPrintTemplateType.Netcost ?
          this.getNetcostPrintTemplate(delivery, resourceName, customerName, customerPhone, customerAddress, barcode, deliveryId, totalCopies, printedCopies, notAfter) :
          (labelPrintTemplateType === LabelPrintTemplateType.Bergstrom ?
            this.getBergstromPrintTemplate2ForPdf(delivery, accountName, resourceName, customerName, businessName, customerPhone, customerAddress, barcode, deliveryId, totalCopies, printedCopies, (itemCount + 1), item.count) :
            this.getDefaultPrintTemplate(delivery, (resourceName || accountName), customerName, businessName, customerPhone, customerAddress, barcode, deliveryId, totalCopies, printedCopies, (itemCount + 1), item.count))
        zplList.push(this.getFinalizeTemplate(template));
      })
    });

    if (!zplList.length) {
      return;
    }

    return this._downloadZplAsPdf(zplList, `labels-${deliveryId}.pdf`);
  };


  // ******************************
  //        Private methods
  // ******************************

  private _downloadZplAsPdf(zplList: string[], fileName: string) {
    const widthMm = 101.6;   // 4 inches
    const heightMm = 152.4;  // 6 inches
    const dpmm = 8;          // 203 DPI

    const renderPromises = _.map(zplList, (zpl) => this.$q.when(zplToBase64Async(zpl, widthMm, heightMm, dpmm)));

    return this.$q.all(renderPromises)
      .then((base64Images: string[]) => {

        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: [widthMm, heightMm]
        });

        _.forEach(base64Images, (base64Image, index) => {
          // jsPDF starts with one blank page, so only add pages for the following labels
          if (index > 0) {
            pdf.addPage([widthMm, heightMm], 'portrait');
          }

          pdf.addImage(
            'data:image/png;base64,' + base64Image,
            'PNG',
            0,
            0,
            widthMm,
            heightMm
          );
        });

        pdf.save(fileName);
      });
  }


  private write(printer, template, copies, copiesPrinted?, retries?) {

    if (!retries) {
      retries = 0
    }

    if (!copiesPrinted) {
      copiesPrinted = 0;
    }

    if (retries < 3) {
      // printer.send(template, _printComplete, _printError);
      this.browserPrintRef.print(template)
        .then((template) => {
          this.$log.debug('Printing is done');
        })
        .catch((error) => {
          retries++;
          this.write(printer, template, copies, copiesPrinted, retries);
        })
    }

    // function _printComplete() {
    //   this.$log.debug('Printing is done');
    // }
    //
    // function _printError() {
    //   retries++;
    //   this.write(printer, template, copies, copiesPrinted, retries);
    // }
  }

  private getNetcostPrintTemplate(delivery, resourceName, customerName, customerPhone, customerAddress, barcode, deliveryId, copies, printedCopies, notAfter) {
    const header = this.getHeaderPayload(resourceName),
      body = this.getBodyPayload(delivery, customerName, customerPhone, customerAddress, notAfter, copies, printedCopies),
      barcodeTemplate = this.getBarcodePayload(barcode);

    return header + body + barcodeTemplate;
  }

  //Top section with name/date/count.

  private getHeaderPayload(resourceName, copies?, printedCopies?) {

    return "^CF0,60" +
      "^FO20,40^FD" + resourceName + "^FS" +
      "^CF0,40" +
      "^FO10,110^GB780,1,3^FS";
  }

  private getBodyPayload(delivery, customerName, customerPhone, address, notAfter, copies, printedCopies) {
    let addressRowOne,
      addressRowTwo,
      floor = address.floor || '--',
      apartment = address.apartment || '--',
      deliveryDate = this.$filter('bringozFullDate')(delivery.notBefore ? delivery : delivery.destination, 'notBefore'),
      timeWindow = this.$filter('timeWindow')(delivery),
      notBeforeTime = this.$filter('bringozTime')(delivery.notBefore ? delivery : delivery.destination, 'notBefore'),
      notAfterTime = this.$filter('bringozTime')(delivery.notAfter ? delivery : delivery.destination, 'notAfter');

    if (address.address1) {
      addressRowOne = _.get(address, 'address1', '') + ' ' + _.get(address, 'address2', '');
      addressRowTwo = address.city + ', ' + address.state + ' ' + _.get(address, 'zipCode', '');
    } else {
      const addressRef = this.$filter('bringozAddress')(address);
      const endFirstRowindex = addressRef.indexOf(",");
      addressRowOne = addressRef.substr(0, endFirstRowindex); // Gets the first row
      addressRowTwo = addressRef.substr(endFirstRowindex + 2); // Gets the second row
    }

    // return "^CFA,25" +
    //   "^FO20,130^FD" + customerName + "^FS" +
    //   "^FO20,170^FD" + addressRowOne + "^FS " +
    //   "^FO20,210^FD" + addressRowTwo + "^FS" +
    //   "^CFA,25" +
    //   "^FO580,130^FDDeliver By:^FS" +
    //   "^CFA,20" +
    //   "^FO580,170^FD" + deliveryDate + "^FS" +
    //   "^FO580,190^FD" + `${notBeforeTime} - ${notAfterTime}` + "^FS" +
    //   "^FO580,220^FDPackage: " + printedCopies + " of " + copies + "^FS" +
    //   "^CFA,20\n" +
    //   "^FO20,250^FDFloor:" + floor + " Apt:" + apartment + "^FS";

    return "^CFA,25" +
      "^FO20,130^FD" + customerName + "^FS" +
      "^FO20,170^FD" + customerPhone + "^FS" +
      "^FO20,210^FD" + addressRowOne + "^FS " +
      "^FO20,250^FD" + addressRowTwo + "^FS" +
      "^CFA,25" +
      "^FO580,130^FDDeliver By:^FS" +
      "^CFA,20" +
      "^FO580,170^FD" + deliveryDate + "^FS" +
      "^FO580,190^FD" + `${notBeforeTime} - ${notAfterTime}` + "^FS" +
      "^FO580,220^FDPackage: " + printedCopies + " of " + copies + "^FS" +
      "^CFA,20\n" +
      "^FO20,290^FDFloor:" + floor + " Apt:" + apartment + "^FS" +
      "^FO20,320^FD" + `${delivery.id}` + "^FS";
  }

  private getBarcodePayload(barcode) {

    if (!barcode) {
      return "";
    }

    return "^BY3,2,270" +
      "^FO300,290^BC,90,Y,N,N" +
      "^FD" + barcode + "^FS";

    // return "^BY3,2,270" +
    //   "^FO125,290^BC,90,Y,N,N" +
    //   "^FD" + barcode + "^FS";

    // return "^BY3,2,270^FO90,350^BY4^BCN,150,Y,N,Y,N^FH\\^FD>;>${barcode}^FS";

    // return "^BY3,2,270" +
    //   `^FO90,350^BY4^BCN,150,Y,N,Y,N^FD>;>${barcode}^FS`;


    // return "^BY3,2,270" +
    //   "^FO125,350^BC,90,Y,N,N" +
    //   "^FD" + barcode + "^FS";
  }

  private getFinalizeTemplate(template) {
    return "^XA" + template + "^XZ";
  }


  private getDefaultPrintTemplate(delivery, resourceName, customerName, businessName, customerPhone, address, barcode, deliveryId, copies, printedCopies, itemCount, totalCount) {

    let addressRowOne,
      addressRowTwo,
      floor = address.floor || '--',
      apartment = address.apartment || '--',
      deliveryDate = this.$filter('bringozFullDate')(delivery.notBefore ? delivery : delivery.destination, 'notBefore'),
      externalId = delivery.externalId,
      timeWindow = this.$filter('timeWindow')(delivery),
      notBeforeTime = this.$filter('bringozTime')(delivery.notBefore ? delivery : delivery.destination, 'notBefore'),
      notAfterTime = this.$filter('bringozTime')(delivery.notAfter ? delivery : delivery.destination, 'notAfter');

    if (address.address1) {
      addressRowOne = _.get(address, 'address1', '') + ' ' + _.get(address, 'address2', '');
      addressRowTwo = address.city + ', ' + address.state + ' ' + _.get(address, 'zipCode', '');
    } else {
      const addressRef = this.$filter('bringozAddress')(address);
      const endFirstRowindex = addressRef.indexOf(",");
      addressRowOne = addressRef.substr(0, endFirstRowindex); // Gets the first row
      addressRowTwo = addressRef.substr(endFirstRowindex + 2); // Gets the second row
    }

//  ^FO50,50^GFA,2210,2210,17,,::::::::::::::::::::::::::::::::::::::::::3gQF,:3PFEO0QF,3NFES0OF,3MF8U07MF,3LF8W03LF,3KF8Y03KF,3JFCgG07JF,3IFEgI0JF,3IFgJ03IF,3FFCgK0IF,3FFgL03FF,3FCgM0FF,3F8gM03F,3FI0FFE07FE1FF83JF007IFI01F,3CI0FFE07FE3FF03JF807IFJ0F,38I0FFE07FE3FE03JF007IFJ07,38I0FFE07FE7FE03JF80JFJ03,3J0FFE07FEFFC03FFJ0JF8I03,3J0FFE07JF803FFI01JF8I01,2J0FFE07JF803IFE01JFCI01,2J0FFE07JF803IFE01JFC,2J0FFE07JFC03IFE03FEFFC,2J0FFE07JFC03IFE03FCFFEI01,3J0FFE07JFE03FFI03JFEI01,3J0FFE07FEIF03FFI07KFI03,38I0FFE07FE7FF03JF07KFI03,38I0FFE07FE7FF83JF0FF83FF8007,3CI0FFE07FE3FF83JF0FF03FF800F,3EI0FFE07FE3FFC3JF0FF01FF801F,3FgN03F,3FCgM0FF,3FFgL01FF,3FFCgK07FF,3IFgJ01IF,3IFCgI0JF,3JF8gG03JF,3KFg03KF,3LFX01LF,3MFV03MF,3NFCS07NF,3PF8O03PF,3SFCI0TF,3gQF,,::::::::::::::::::::::::::::::::::::::::::^FS


    return `

^FX Top section with logo, name and address.
^CF0,60
^FO50,85^FD${resourceName}^FS
^CFA,30
^FO50,170^FD${deliveryDate}^FS
^FO50,210^FD${notBeforeTime} - ${notAfterTime}^FS
^FO50,250^GB700,3,3^FS

^FX Second section with recipient address and permit information.
^CFA,30
^FO50,280^FDShip To:^FS
^FO50,320^FD${businessName || '--'} ${(!!businessName && !!customerName) ? '/' : ''} ${customerName || ''}^FS
^FO50,360^FD${customerPhone || '--'}^FS
^FO50,400^FDS${addressRowOne || '--'}^FS
^FO50,440^FD${addressRowTwo || '--'}^FS
^CFA,15
^FO50,500^GB700,3,3^FS

^FX Third section with bar code.
^BY4,2,170
^FO50,550
^FB700,1,0,C,0
^BC,170,Y,N,N
^FD${barcode || ''}^FS

^FX Fourth section (the box on the bottom).
^FO50,900^GB700,250,3^FS
^CF0,40
^FO100,960^FDPackage: ${printedCopies} of ${copies}  Item: ${itemCount} / ${totalCount}^FS
^FO100,1010^FDFloor: ${floor} Apt: ${apartment}^FS
^FO100,1060^FD${externalId || deliveryId}  Invoice: ${delivery.invoiceNumber || '--'}^FS
^CF0,190
`
  }

  private getBergstromPrintTemplate(delivery, accountName, customerName, businessName, customerPhone, address, barcode, deliveryId, copies, printedCopies, itemCount, totalCount) {

    let addressRowOne,
      addressRowTwo,
      siteName = this.splitService.getSiteName(),
      floor = address.floor || '--',
      apartment = address.apartment || '--',
      deliveryDate = this.$filter('bringozFullDate')(delivery.notBefore ? delivery : delivery.destination, 'notBefore'),
      externalId = delivery.externalId,
      extraInfo = _.get( _.last(delivery.taskList), 'taskSpec.extraInfo', '--'),
      timeWindow = this.$filter('timeWindow')(delivery),
      notBeforeTime = this.$filter('bringozTime')(delivery.notBefore ? delivery : delivery.destination, 'notBefore'),
      notAfterTime = this.$filter('bringozTime')(delivery.notAfter ? delivery : delivery.destination, 'notAfter');

    if (address.address1) {
      addressRowOne = _.get(address, 'address1', '') + ' ' + _.get(address, 'address2', '');
      addressRowTwo = address.city + ', ' + address.state + ' ' + _.get(address, 'zipCode', '');
    } else {
      const addressRef = this.$filter('bringozAddress')(address);
      const endFirstRowindex = addressRef.indexOf(",");
      addressRowOne = addressRef.substr(0, endFirstRowindex); // Gets the first row
      addressRowTwo = addressRef.substr(endFirstRowindex + 2); // Gets the second row
    }

//  ^FO50,50^GFA,2210,2210,17,,::::::::::::::::::::::::::::::::::::::::::3gQF,:3PFEO0QF,3NFES0OF,3MF8U07MF,3LF8W03LF,3KF8Y03KF,3JFCgG07JF,3IFEgI0JF,3IFgJ03IF,3FFCgK0IF,3FFgL03FF,3FCgM0FF,3F8gM03F,3FI0FFE07FE1FF83JF007IFI01F,3CI0FFE07FE3FF03JF807IFJ0F,38I0FFE07FE3FE03JF007IFJ07,38I0FFE07FE7FE03JF80JFJ03,3J0FFE07FEFFC03FFJ0JF8I03,3J0FFE07JF803FFI01JF8I01,2J0FFE07JF803IFE01JFCI01,2J0FFE07JF803IFE01JFC,2J0FFE07JFC03IFE03FEFFC,2J0FFE07JFC03IFE03FCFFEI01,3J0FFE07JFE03FFI03JFEI01,3J0FFE07FEIF03FFI07KFI03,38I0FFE07FE7FF03JF07KFI03,38I0FFE07FE7FF83JF0FF83FF8007,3CI0FFE07FE3FF83JF0FF03FF800F,3EI0FFE07FE3FFC3JF0FF01FF801F,3FgN03F,3FCgM0FF,3FFgL01FF,3FFCgK07FF,3IFgJ01IF,3IFCgI0JF,3JF8gG03JF,3KFg03KF,3LFX01LF,3MFV03MF,3NFCS07NF,3PF8O03PF,3SFCI0TF,3gQF,,::::::::::::::::::::::::::::::::::::::::::^FS


    return `

^FX Top section with logo, name and address.
^FO50,50^GFA,3240,3240,18,,::::::::::::::::::::::::::::::::::::::::gK0CE,gJ01IFE,gJ03JF,gJ07800F8,gJ0EI07C,gI01EI03C,gI03C0FC1C,gI0781FE1C,gI0F01FE1C,gH01E03FF1C,gH03E03011C,gH07C06001C1,gH0F80600181,gH0F00C00383,gG01E00C00307,gG03C0180260F,gG07801800C1E,gG0F00380183E,g01F00300707C,g03E00704707C,g07C006043838,g0F800E061C1,Y01FI0C070E,Y03F001C0787,Y07E001807838,Y0FC003803C3C,X01F8003803C1C,X03FI07001C1E,X07EI07I0C0E,X0FEI0EI0C0E,X0FCI0EI0C0F,W03F8001CI040F,W07FI01CI040F,W07EI038I040F,R013JFCFF878K0F,Q01LFCJFL0F,Q01LF8JFL0F,Q01LF0JFL0F,Q01KFE0IFEL0F,gN01F,:gN03F,gN03E01,gN07E01,gN0FE01,gM03FC01,gM0FFC01,gG07I03IF801,N0gGF003,N0gFE003,N0gFC002,N0gFI02,N0YF8I06,gQ06,:gQ0E,gP01C,gP03C,gP07C,gP0F8,gO03F8,gO0FF,gN0IF,I0gMFE,I0gMFC,I0gMF8,I0gMF,I0gLFE,I0gLF8,I0gKFE,I0gKF,,::::I0FE07FCFE00F80F8IF73007C0600C,I0FF8FFCFF03FF1MFC1FF0F01E,I0FFC7FCFF87FF3MFE3FF8781E,I0F3C700E7CFDF3C60E079E3FFC783E,I0E1C700E1CF017800E070E781C7C7E,I0E1CF00E1DE007800E070E701E7E7E,I0E1C701E3DE003C00E070EF00E7FFE,I0FF87FCE39C003F00E07BEE00E7FEE,I0FF87FCFF1C003FC0E07FCE00E77CE,I0FFC7FDFF1C1F8FE0E07F8E00E73CE,I0E1E701EF1C1F07E0E07BCE00E738E,I0E0E700E79E0F01E0E071CF00E710E,I0E0E700E39E0700E0E071E701E700E,I0E0E700E3CF0720E0E070E783C700E,I0F1E700E1CIF31E0E070F3FFC700E,I0FFE7FCE1C7FF3FE0E070F3FF8700E,I0FFCFFCE1E3FF3FC0E07070FF0F00E,I0FF07FCC0E0700700605050380600C,,::::::::::::::::::::::::::::::::::::::::::::^FS
^CF0,60
^FO220,85^FD${siteName}^FS
^CF0,40
^FO220,155^FD${this.$filter('translate')('Account')}: ${accountName}^FS
^CFA,30
^FO50,240^FD${this.$filter('translate')('Date')}: ${deliveryDate}^FS
^FO50,280^FD${this.$filter('translate')('Time')}: ${notBeforeTime} - ${notAfterTime}^FS
^FO50,320^GB700,3,3^FS

^FX Second section with recipient address and permit information.
^CFA,30
^FO50,350^FDShip To:^FS
^FO50,390^FD${businessName || '--'} ${(!!businessName && !!customerName) ? '/' : ''} ${customerName || ''}^FS
^FO50,430^FD${customerPhone || '--'}^FS
^FO50,470^FDS${addressRowOne || '--'}^FS
^FO50,510^FD${addressRowTwo || '--'}^FS
^CFA,15
^FO50,570^GB700,3,3^FS

^FX Third section with bar code.
^BY4,2,170
^FO50,620
^FB700,1,0,C,0
^BC,170,Y,N,N
^FD${barcode || ''}^FS

^FX Fourth section (the box on the bottom).
^FO50,900^GB700,250,3^FS
^CF0,35
^FO70,930^FDPackage: ${printedCopies} of ${copies}  Item: ${itemCount} / ${totalCount}^FS
^FO70,980^FD${this.$filter('translate')('Invoice')}: ${delivery.invoiceNumber || '--'}^FS
^FO70,1030^FD${this.$filter('translate')('Ext ID')}: ${externalId || deliveryId}^FS
^CFA,28
^FO70,1080
^FB700,2,0,L,0
^FD${this.$filter('translate')('Instructions')}: ${extraInfo}^FS
^CF0,190
`
  }

  private getBergstromPrintTemplate2(delivery, accountName, resourceName, customerName, businessName, customerPhone, address, barcode, deliveryId, copies, printedCopies, itemCount, totalCount) {

    const programTypesMap = this.splitService.getSiteProgramTypesMap();
    const totalServiceItemsCount = _.get(delivery, 'packageList[0].count');

    let addressRowOne,
      addressRowTwo,
      siteName = this.splitService.getSiteName(),
      floor = address.floor || '--',
      apartment = address.apartment || '--',
      deliveryDate = this.$filter('bringozFullDate')(delivery.notBefore ? delivery : delivery.destination, 'notBefore'),
      externalId = delivery.externalId,
      programName = programTypesMap[delivery.pricePlanType],
      extraInfo = _.get( _.last(delivery.taskList), 'taskSpec.extraInfo', '--'),
      timeWindow = this.$filter('timeWindow')(delivery),
      metadata = _.keyBy(delivery.metaData, 'key') || {},
      notBeforeTime = this.$filter('bringozTime')(delivery.notBefore ? delivery : delivery.destination, 'notBefore'),
      notAfterTime = this.$filter('bringozTime')(delivery.notAfter ? delivery : delivery.destination, 'notAfter');

    if (address.address1) {
      addressRowOne = _.get(address, 'address1', '') + ' ' + _.get(address, 'address2', '');
      addressRowTwo = address.city + ', ' + address.state + ' ' + _.get(address, 'zipCode', '');
    } else {
      const addressRef = this.$filter('bringozAddress')(address);
      const endFirstRowindex = addressRef.indexOf(",");
      addressRowOne = addressRef.substr(0, endFirstRowindex); // Gets the first row
      addressRowTwo = addressRef.substr(endFirstRowindex + 2); // Gets the second row
    }

//  ^FO50,50^GFA,2210,2210,17,,::::::::::::::::::::::::::::::::::::::::::3gQF,:3PFEO0QF,3NFES0OF,3MF8U07MF,3LF8W03LF,3KF8Y03KF,3JFCgG07JF,3IFEgI0JF,3IFgJ03IF,3FFCgK0IF,3FFgL03FF,3FCgM0FF,3F8gM03F,3FI0FFE07FE1FF83JF007IFI01F,3CI0FFE07FE3FF03JF807IFJ0F,38I0FFE07FE3FE03JF007IFJ07,38I0FFE07FE7FE03JF80JFJ03,3J0FFE07FEFFC03FFJ0JF8I03,3J0FFE07JF803FFI01JF8I01,2J0FFE07JF803IFE01JFCI01,2J0FFE07JF803IFE01JFC,2J0FFE07JFC03IFE03FEFFC,2J0FFE07JFC03IFE03FCFFEI01,3J0FFE07JFE03FFI03JFEI01,3J0FFE07FEIF03FFI07KFI03,38I0FFE07FE7FF03JF07KFI03,38I0FFE07FE7FF83JF0FF83FF8007,3CI0FFE07FE3FF83JF0FF03FF800F,3EI0FFE07FE3FFC3JF0FF01FF801F,3FgN03F,3FCgM0FF,3FFgL01FF,3FFCgK07FF,3IFgJ01IF,3IFCgI0JF,3JF8gG03JF,3KFg03KF,3LFX01LF,3MFV03MF,3NFCS07NF,3PF8O03PF,3SFCI0TF,3gQF,,::::::::::::::::::::::::::::::::::::::::::^FS


    return `

^DFR:BERGSTROM.FMT^FS

^FX ======= HEADER: Logo + Titles =======
^FX Top section with logo, name and address.
^FO30,20^GFA,3240,3240,18,,::::::::::::::::::::::::::::::::::::::::gK0CE,gJ01IFE,gJ03JF,gJ07800F8,gJ0EI07C,gI01EI03C,gI03C0FC1C,gI0781FE1C,gI0F01FE1C,gH01E03FF1C,gH03E03011C,gH07C06001C1,gH0F80600181,gH0F00C00383,gG01E00C00307,gG03C0180260F,gG07801800C1E,gG0F00380183E,g01F00300707C,g03E00704707C,g07C006043838,g0F800E061C1,Y01FI0C070E,Y03F001C0787,Y07E001807838,Y0FC003803C3C,X01F8003803C1C,X03FI07001C1E,X07EI07I0C0E,X0FEI0EI0C0E,X0FCI0EI0C0F,W03F8001CI040F,W07FI01CI040F,W07EI038I040F,R013JFCFF878K0F,Q01LFCJFL0F,Q01LF8JFL0F,Q01LF0JFL0F,Q01KFE0IFEL0F,gN01F,:gN03F,gN03E01,gN07E01,gN0FE01,gM03FC01,gM0FFC01,gG07I03IF801,N0gGF003,N0gFE003,N0gFC002,N0gFI02,N0YF8I06,gQ06,:gQ0E,gP01C,gP03C,gP07C,gP0F8,gO03F8,gO0FF,gN0IF,I0gMFE,I0gMFC,I0gMF8,I0gMF,I0gLFE,I0gLF8,I0gKFE,I0gKF,,::::I0FE07FCFE00F80F8IF73007C0600C,I0FF8FFCFF03FF1MFC1FF0F01E,I0FFC7FCFF87FF3MFE3FF8781E,I0F3C700E7CFDF3C60E079E3FFC783E,I0E1C700E1CF017800E070E781C7C7E,I0E1CF00E1DE007800E070E701E7E7E,I0E1C701E3DE003C00E070EF00E7FFE,I0FF87FCE39C003F00E07BEE00E7FEE,I0FF87FCFF1C003FC0E07FCE00E77CE,I0FFC7FDFF1C1F8FE0E07F8E00E73CE,I0E1E701EF1C1F07E0E07BCE00E738E,I0E0E700E79E0F01E0E071CF00E710E,I0E0E700E39E0700E0E071E701E700E,I0E0E700E3CF0720E0E070E783C700E,I0F1E700E1CIF31E0E070F3FFC700E,I0FFE7FCE1C7FF3FE0E070F3FF8700E,I0FFCFFCE1E3FF3FC0E07070FF0F00E,I0FF07FCC0E0700700605050380600C,,::::::::::::::::::::::::::::::::::::::::::::^FS



^CF0,40
^FO180,80
^FB600,2,0,L,0       ; width=600 dots, max 2 lines, no extra spacing, Left aligned
^FN15^FS             ; FN15 will wrap to a 2nd line automatically
^FX 15 = Account Name


^CF0,40

^FX ======= SHIP TO BAND =======
^FO30,170^GB752,50,50,B^FS
^FO350,182^FR^A0N,34,34^FD SHIP TO:^FS

^FX Ship-to block (Name, address, phone)
^FO30,230^A0N,36,36^FN1^FS
^FO30,270^GB750,3,3^FS ;Divider
^FO30,290^A0N,30,30^FN2^FS         ^FX 2 = Address line 1 (e.g., S5901 Odana Road)
^FO30,330^A0N,30,30^FN3^FS         ^FX 3 = City, State ZIP (e.g., Madison, WI 53719)
^FO550,290^A0N,30,30^FN4^FS        ^FX 4 = Phone (e.g., 608-212-0382)



^FX ======= DELIVERY ID / PACKAGES =======
^FO30,370^GB250,50,50,B^FS
^FO35,382^FR^A0N,28,28^FDINVOICE#^FS
^FO280,370^GB250,50,50,B^FS
^FO300,382^FR^A0N,28,28^FDPAYMENT TYPE^FS
^FO530,370^GB252,50,50,B^FS
^FO600,382^FR^A0N,28,28^FDPACKAGES^FS

^FO30,435^A0N,32,32^FN5^FS        ^FX 5 = External ID
^FO300,435^A0N,32,32^FN9^FS        ^FX 9 = Payment Type
^FO600,435^A0N,32,32^FN6^FS        ^FX 6 = Packages (e.g., 1 of 3)






^FX ======= SO / RO =======
^FO30,480^GB376,50,50,B^FS
^FO30,492^FR^A0N,28,28^FD PO#^FS
^FO406,480^GB376,50,50,B^FS
^FO426,492^FR^A0N,28,28^FD RO#^FS

^FO30,550^A0N,32,32^FN7^FS         ^FX 7 = PO# (e.g., 22612)
^FO426,550^A0N,32,32^FN8^FS        ^FX 8 = RO# (e.g., 12345AA)




^FX ======= ROUTE / ETA =======
^FO30,600^GB376,50,50,B^FS
^FO30,615^FR^A0N,28,28^FD ROUTE#^FS
^FO406,600^GB376,50,50,B^FS
^FO426,615^FR^A0N,28,28^FD DATE^FS

^FO30,670^A0N,32,32^FN10^FS        ^FX 10 = Resource
^FO426,670^A0N,32,32^FN11^FS       ^FX 11 = DATE line 1 (e.g., 8/26/2025)
^FO30,730^A0N,32,32^FN12^FS        ^FX 12 = Program

^FO30,780^GB750,3,3^FS ;Divider

^FX ======= EXTENDED BARCODE (FULL WIDTH) =======
^${barcode?.length >= 13 ? 'BY3' : (barcode?.length <= 9 ? 'BY5' : 'BY4')},3,260          ; 4-16 characters
^FO50,830           ; left align with page content (same as headers)
^BCN,150,Y,N,N
^FN14^FS

^FO30,1100^FD${this.$filter('translate')('Instructions')}: ^FS
^FO30,1150^A0N,32,32^FN16^FS        ^FX 16 = Extra Info

^XZ
2) Print a label by merging your data with the format
zpl
Copy code
^XA
^XFR:BERGSTROM.FMT^FS
^FN1^FD${businessName || customerName || '--'}^FS
^FN2^FD${addressRowOne || '--'}^FS
^FN3^FD${addressRowTwo || '--'}^FS
^FN4^FD${customerPhone || '--'}^FS
^FN5^FD${externalId || deliveryId}^FS
^FN6^FD${printedCopies} of ${totalServiceItemsCount}^FS
^FN7^FD${metadata.PO?.value || '--'}^FS
^FN8^FD${metadata.RO?.value || '--'}^FS
^FN9^FD${(metadata.paymentType?.value || '')} $${metadata.amount?.value || '--'}^FS
^FN10^FD${resourceName || '--'}^FS
^FN11^FD${deliveryDate || '--'}^FS
^FN12^FD${programName || '--'}^FS
^FN14^FD${barcode || '--'}^FS
^FN15^FD${accountName || '--'}^FS
^FN16^FD${extraInfo || ''}^FS
`
  }

  private getBergstromPrintTemplate2ForPdf(delivery, accountName, resourceName, customerName, businessName, customerPhone, address, barcode, deliveryId, copies, printedCopies, itemCount, totalCount) {

    const programTypesMap = this.splitService.getSiteProgramTypesMap();
    const totalServiceItemsCount = _.get(delivery, 'packageList[0].count');

    let addressRowOne,
      addressRowTwo,
      siteName = this.splitService.getSiteName(),
      floor = address.floor || '--',
      apartment = address.apartment || '--',
      deliveryDate = this.$filter('bringozFullDate')(delivery.notBefore ? delivery : delivery.destination, 'notBefore'),
      externalId = delivery.externalId,
      programName = programTypesMap[delivery.pricePlanType],
      extraInfo = _.get( _.last(delivery.taskList), 'taskSpec.extraInfo', '--'),
      timeWindow = this.$filter('timeWindow')(delivery),
      metadata = _.keyBy(delivery.metaData, 'key') || {},
      notBeforeTime = this.$filter('bringozTime')(delivery.notBefore ? delivery : delivery.destination, 'notBefore'),
      notAfterTime = this.$filter('bringozTime')(delivery.notAfter ? delivery : delivery.destination, 'notAfter');

    if (address.address1) {
      addressRowOne = _.get(address, 'address1', '') + ' ' + _.get(address, 'address2', '');
      addressRowTwo = address.city + ', ' + address.state + ' ' + _.get(address, 'zipCode', '');
    } else {
      const addressRef = this.$filter('bringozAddress')(address);
      const endFirstRowindex = addressRef.indexOf(",");
      addressRowOne = addressRef.substr(0, endFirstRowindex); // Gets the first row
      addressRowTwo = addressRef.substr(endFirstRowindex + 2); // Gets the second row
    }

    function byForBarcode(barcode) {
      const len = (barcode || '').toString().trim().length;
      if (len >= 13) return '^BY3,3,260';
      if (len <= 9)  return '^BY5,3,260';
      return '^BY4,3,260';
    }

    const byCmd = byForBarcode(barcode);


//  ^FO50,50^GFA,2210,2210,17,,::::::::::::::::::::::::::::::::::::::::::3gQF,:3PFEO0QF,3NFES0OF,3MF8U07MF,3LF8W03LF,3KF8Y03KF,3JFCgG07JF,3IFEgI0JF,3IFgJ03IF,3FFCgK0IF,3FFgL03FF,3FCgM0FF,3F8gM03F,3FI0FFE07FE1FF83JF007IFI01F,3CI0FFE07FE3FF03JF807IFJ0F,38I0FFE07FE3FE03JF007IFJ07,38I0FFE07FE7FE03JF80JFJ03,3J0FFE07FEFFC03FFJ0JF8I03,3J0FFE07JF803FFI01JF8I01,2J0FFE07JF803IFE01JFCI01,2J0FFE07JF803IFE01JFC,2J0FFE07JFC03IFE03FEFFC,2J0FFE07JFC03IFE03FCFFEI01,3J0FFE07JFE03FFI03JFEI01,3J0FFE07FEIF03FFI07KFI03,38I0FFE07FE7FF03JF07KFI03,38I0FFE07FE7FF83JF0FF83FF8007,3CI0FFE07FE3FF83JF0FF03FF800F,3EI0FFE07FE3FFC3JF0FF01FF801F,3FgN03F,3FCgM0FF,3FFgL01FF,3FFCgK07FF,3IFgJ01IF,3IFCgI0JF,3JF8gG03JF,3KFg03KF,3LFX01LF,3MFV03MF,3NFCS07NF,3PF8O03PF,3SFCI0TF,3gQF,,::::::::::::::::::::::::::::::::::::::::::^FS


    return `

^DFR:BERGSTROM.FMT^FS

^FX ======= HEADER: Logo + Titles =======
^FX Top section with logo, name and address.
^FO30,20^GFA,3240,3240,18,,::::::::::::::::::::::::::::::::::::::::gK0CE,gJ01IFE,gJ03JF,gJ07800F8,gJ0EI07C,gI01EI03C,gI03C0FC1C,gI0781FE1C,gI0F01FE1C,gH01E03FF1C,gH03E03011C,gH07C06001C1,gH0F80600181,gH0F00C00383,gG01E00C00307,gG03C0180260F,gG07801800C1E,gG0F00380183E,g01F00300707C,g03E00704707C,g07C006043838,g0F800E061C1,Y01FI0C070E,Y03F001C0787,Y07E001807838,Y0FC003803C3C,X01F8003803C1C,X03FI07001C1E,X07EI07I0C0E,X0FEI0EI0C0E,X0FCI0EI0C0F,W03F8001CI040F,W07FI01CI040F,W07EI038I040F,R013JFCFF878K0F,Q01LFCJFL0F,Q01LF8JFL0F,Q01LF0JFL0F,Q01KFE0IFEL0F,gN01F,:gN03F,gN03E01,gN07E01,gN0FE01,gM03FC01,gM0FFC01,gG07I03IF801,N0gGF003,N0gFE003,N0gFC002,N0gFI02,N0YF8I06,gQ06,:gQ0E,gP01C,gP03C,gP07C,gP0F8,gO03F8,gO0FF,gN0IF,I0gMFE,I0gMFC,I0gMF8,I0gMF,I0gLFE,I0gLF8,I0gKFE,I0gKF,,::::I0FE07FCFE00F80F8IF73007C0600C,I0FF8FFCFF03FF1MFC1FF0F01E,I0FFC7FCFF87FF3MFE3FF8781E,I0F3C700E7CFDF3C60E079E3FFC783E,I0E1C700E1CF017800E070E781C7C7E,I0E1CF00E1DE007800E070E701E7E7E,I0E1C701E3DE003C00E070EF00E7FFE,I0FF87FCE39C003F00E07BEE00E7FEE,I0FF87FCFF1C003FC0E07FCE00E77CE,I0FFC7FDFF1C1F8FE0E07F8E00E73CE,I0E1E701EF1C1F07E0E07BCE00E738E,I0E0E700E79E0F01E0E071CF00E710E,I0E0E700E39E0700E0E071E701E700E,I0E0E700E3CF0720E0E070E783C700E,I0F1E700E1CIF31E0E070F3FFC700E,I0FFE7FCE1C7FF3FE0E070F3FF8700E,I0FFCFFCE1E3FF3FC0E07070FF0F00E,I0FF07FCC0E0700700605050380600C,,::::::::::::::::::::::::::::::::::::::::::::^FS



^CF0,40
^FO180,80
^FB600,2,0,L,0       ; width=600 dots, max 2 lines, no extra spacing, Left aligned
^FN15^FS             ; FN15 will wrap to a 2nd line automatically
^FX 15 = Account Name


^CF0,40

^FX ======= SHIP TO BAND =======
^FO30,170^GB752,50,50,B^FS
^FO350,182^FR^A0N,34,34^FD SHIP TO:^FS

^FX Ship-to block (Name, address, phone)
^FO30,230^A0N,36,36^FN1^FS
^FO30,270^GB750,3,3^FS ;Divider
^FO30,290^A0N,30,30^FN2^FS         ^FX 2 = Address line 1 (e.g., S5901 Odana Road)
^FO30,330^A0N,30,30^FN3^FS         ^FX 3 = City, State ZIP (e.g., Madison, WI 53719)
^FO550,290^A0N,30,30^FN4^FS        ^FX 4 = Phone (e.g., 608-212-0382)



^FX ======= DELIVERY ID / PACKAGES =======
^FO30,370^GB250,50,50,B^FS
^FO35,382^FR^A0N,28,28^FDINVOICE#^FS
^FO280,370^GB250,50,50,B^FS
^FO300,382^FR^A0N,28,28^FDPAYMENT TYPE^FS
^FO530,370^GB252,50,50,B^FS
^FO600,382^FR^A0N,28,28^FDPACKAGES^FS

^FO30,435^A0N,32,32^FN5^FS        ^FX 5 = External ID
^FO300,435^A0N,32,32^FN9^FS        ^FX 9 = Payment Type
^FO600,435^A0N,32,32^FN6^FS        ^FX 6 = Packages (e.g., 1 of 3)






^FX ======= SO / RO =======
^FO30,480^GB376,50,50,B^FS
^FO30,492^FR^A0N,28,28^FD PO#^FS
^FO406,480^GB376,50,50,B^FS
^FO426,492^FR^A0N,28,28^FD RO#^FS

^FO30,550^A0N,32,32^FN7^FS         ^FX 7 = PO# (e.g., 22612)
^FO426,550^A0N,32,32^FN8^FS        ^FX 8 = RO# (e.g., 12345AA)




^FX ======= ROUTE / ETA =======
^FO30,600^GB376,50,50,B^FS
^FO30,615^FR^A0N,28,28^FD ROUTE#^FS
^FO406,600^GB376,50,50,B^FS
^FO426,615^FR^A0N,28,28^FD DATE^FS

^FO30,670^A0N,32,32^FN10^FS        ^FX 10 = Resource
^FO426,670^A0N,32,32^FN11^FS       ^FX 11 = DATE line 1 (e.g., 8/26/2025)
^FO30,730^A0N,32,32^FN12^FS        ^FX 12 = Program

^FO30,780^GB750,3,3^FS ;Divider

^FX ======= EXTENDED BARCODE (FULL WIDTH) =======
${byCmd}
^FO50,830
^BCN,150,Y,N,N
^FD${barcode}^FS

^FO30,1100^FD${this.$filter('translate')('Instructions')}: ^FS
^FO30,1150^A0N,32,32^FN16^FS        ^FX 16 = Extra Info

^XZ
2) Print a label by merging your data with the format
zpl
Copy code
^XA
^XFR:BERGSTROM.FMT^FS
^FN1^FD${businessName || customerName || '--'}^FS
^FN2^FD${addressRowOne || '--'}^FS
^FN3^FD${addressRowTwo || '--'}^FS
^FN4^FD${customerPhone || '--'}^FS
^FN5^FD${externalId || deliveryId}^FS
^FN6^FD${printedCopies} of ${totalServiceItemsCount}^FS
^FN7^FD${(metadata.PO?.value || metadata['tekion.poNumber']?.value) || '--'}^FS
^FN8^FD${(metadata.RO?.value || metadata['tekion.routeNumber']?.value) || '--'}^FS
^FN9^FD${((metadata.paymentType?.value || metadata['tekion.paymentMethod']?.value) || '')} $${(metadata.amount?.value || metadata['tekion.saleAmount']?.value) || '--'}^FS
^FN10^FD${resourceName || '--'}^FS
^FN11^FD${deliveryDate || '--'}^FS
^FN12^FD${programName || '--'}^FS
^FN15^FD${accountName || '--'}^FS
^FN16^FD${extraInfo || ''}^FS
`
  }


}

angular
  .module('bringoz.admin.commons')
  .service('printerService', PrinterService);
